"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Inmates = void 0;
const sdk_1 = require("../sdk");
var Inmates;
(function (Inmates) {
    Inmates.get = (inmateId, options) => {
        const url = `/inmates/${inmateId}`;
        return sdk_1.SDK.axios.get((0, sdk_1.appendSearchParams)(url, options));
    };
    Inmates.getByCustodyAccout = (inmateId, options) => {
        const url = `/inmates/custody/${inmateId}`;
        return sdk_1.SDK.axios.get((0, sdk_1.appendSearchParams)(url, options));
    };
    Inmates.list = (options) => {
        const url = '/inmates';
        return sdk_1.SDK.axios.get((0, sdk_1.appendSearchParams)(url, options));
    };
})(Inmates = exports.Inmates || (exports.Inmates = {}));
//# sourceMappingURL=inmates.js.map